import React, { Component } from 'react'
import http from '../http'

export class ContentService extends Component {
  getContent(){
      return http.get('/home/')
  }
}

export default new ContentService()